var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-change-rolesandusers',{ref:"changeApprovalUserRole",attrs:{"userRoleId":_vm.mainUserRoleId,"disabled":_vm.disableEditing,"creating":_vm.creating}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }